export default "__VITE_ASSET__soKnqkra__"